import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative isolate" }
const _hoisted_2 = { class: "mx-auto flex flex-wrap items-center justify-center relative z-10" }

import type { BackgroundComponentProps } from "./BackgroundComponentProps";

// background have to be 6 char hex

export default /*@__PURE__*/_defineComponent({
  __name: 'BackgroundComponent',
  props: {
    primaryColor: {},
    backgroundColor: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "af37f80e": (_ctx.primaryColor),
  "1326fb46": (_ctx.backgroundColor)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "dots-background" }, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "horizontal-gradient-overlay" }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "gradient-overlay" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})